import api from './api';

export function getDirectories() {
  return api.get('/api/v2/directories');
}

export function getDirectory(directoryId) {
  return api.get(`/api/v2/directories/${directoryId}`);
}

export function updateDirectory(directory) {
  return api.put(`/api/v2/directories/${directory.id}`, {
    ...directory,
  });
}

export function createDirectory(directoryName) {
  return api.post(`/api/v2/directories`, {
    name: directoryName ? directoryName : 'Nouveau répertoire',
    is_global: false,
    entries: [],
  });
}

export function deleteDirectory(directoryId) {
  return api.delete(`/api/v2/directories/${directoryId}`);
}
